module.exports = __webpack_public_path__ + "assets/new.d0a84f52.svg";